import React from 'react';
import { FooterContainer } from './ActionContainer.styles';
import AccountDetailsLink, { getFactSheetUrl } from '../../shared/AccountDetailsLink';
import PlanAction from '../../shared/PlanAction';
import type { PlanId } from '../../types';

interface ActionContainerProps {
  currentPlan: PlanId;
  activeTabId: PlanId;
  isWebview?: boolean;
  switchPermitted: boolean;
  product?: any;
  planName?: string;
  onSelectPlan?: () => void;
  onManage?: () => void;
  onVoucher?: () => void;
}

const ActionContainer: React.FC<ActionContainerProps> = ({
  currentPlan,
  activeTabId,
  isWebview = false,
  switchPermitted,
  product,
  planName,
  onSelectPlan,
  onManage,
  onVoucher,
}) => (
  <FooterContainer>
    <AccountDetailsLink href={getFactSheetUrl(activeTabId)} planName={planName} isWebview={isWebview} />
    <PlanAction
      currentPlanId={currentPlan}
      planId={activeTabId}
      switchPermitted={switchPermitted}
      product={product}
      onSelectPlan={onSelectPlan}
      onManage={onManage}
      onVoucher={onVoucher}
    />
  </FooterContainer>
);

export default ActionContainer;
